import React from 'react'
import * as actionCreators from '../actions/RouterActions'
import { push } from '../actions/RouterActions'

import { Container, Dropdown, Divider, Grid, Header, Image, List, Menu, Segment, Icon, Modal, Button } from 'semantic-ui-react'
import {connect} from 'react-redux'
import {__PREFIX__} from '../constants/UrlPrefix'

const _ = require('lodash')

function mapStateToProps (state, props) {
	let ret = {user: state.user};
	
	if(typeof props === 'undefined' || props === null)
		props = {};
		
	if(typeof props.icon === 'undefined')
		ret.icon = "share alternate";
		
	if(typeof props.title === 'undefined')
		ret.title = "Oddset Feeds";
		
	if(typeof props.menu === 'undefined')
		ret.menu = [
		 	{
		 		icon: 'tasks',
		 		caption: 'Events und Wettprogramm',
		 		auth: ['de.kisad.odst.feeds'],
		 		entries: [
		 			{
		 				icon: 'soccer',
		 				caption: 'Events',
		 				href: '' + __PREFIX__ + 'events',
		 				auth: ['de.kisad.odst.feeds']
		 			},
		 			{
		 				icon: 'sitemap',
		 				caption: 'Struktur',
		 				href: '' + __PREFIX__ + 'Structures',
		 				auth: ['de.kisad.odst.feeds.structures']
		 			},
		 			{
		 				icon: 'paragraph',
		 				caption: 'Kombinations-Regeln',
		 				href: '' + __PREFIX__ + 'constraints',
		 				auth: ['de.kisad.odst.feeds.constraints']
		 			},
		 			{
		 				icon: 'soccer',
		 				caption: 'Eventtypen',
		 				href: '' + __PREFIX__ + 'eventtypes',
		 				auth: ['de.kisad.odst.feeds.eventtypes', 'de.kisad.odst.feeds.dictionaries', 'de.kisad.odst.feeds.markets']
		 			},
		 			{
		 				icon: 'star',
		 				caption: 'Topangebot',
		 				href: '' + __PREFIX__ + 'toplists',
		 				auth: ['de.kisad.odst.feeds.toplists']
		 			}
		 		]
		 	},
		 	{
		 		icon: 'configure',
		 		caption: 'Administration',
		 		auth: ["de.kisad.odst.feeds.captions", "de.kisad.odst.feeds.consumers", "de.kisad.odst.feeds.feeds", "de.kisad.odst.feeds.lotteries", "de.kisad.odst.feeds.monitoring", "de.kisad.odst.feeds.notifications"],
		 		entries: [
					{
						icon: 'share alternate',
						caption: 'Feeds',
						href: '' + __PREFIX__ + 'consumers',
						auth: ['de.kisad.odst.feeds.consumers']
					},
					{
						icon: 'bell',
						caption: 'Benachrichtigungen',
						href: '' + __PREFIX__ + 'notifications',
						auth: ['de.kisad.odst.feeds.notifications']
					},
					{
						icon: 'home',
						caption: 'Lotterien',
						href: '' + __PREFIX__ + 'lotteries',
						auth: ['de.kisad.odst.feeds.lotteries']
					},
					{
						icon: 'book',
						caption: 'Bezeichnungen',
						href: '' + __PREFIX__ + 'captions',
						auth: ['de.kisad.odst.feeds.captions']
					},
					{
						icon: 'heartbeat',
						caption: 'Push-Status',
						href: '' + __PREFIX__ + 'monitorings',
						auth: ['de.kisad.odst.feeds.monitoring']
					}
		 		]
		 	}
		 ];
		
	return ret;
}

class NavigationComponent extends React.Component {	
  constructor(){
	  super();
	  this.state = {
		  search: ''
	  };

	/*if(typeof this.props !== 'undefined' && typeof this.props.menu !== 'undefined')
		 this.menu = this.props.menu;
	else
		 this.menu = [];*/
  }
  
  componentWillMount() {

  }
  
  componentDidUpdate() {

  }
  
  authorized(roles, options){
	let mode = 'any';
	return false;
	if(typeof options !== 'undefined' && options !== null && typeof options.mode !== null && options.mode === "all")
		mode = options.mode;
	
	let valid = false;
	if(mode === 'all')
		valid = true;
	
	for(var i = 0;i < roles.length; i++){
		let role = roles[i];
        let client = '';
        if(typeof this.props.user !== 'undefined' && this.prop.user !== null)
		    client = this.props.user.get('azp');
		
		if(role.indexOf(':') !== -1){
			role = role.split(':');
			client = role.shift();
			role = role.join(':');
		}
				
		if(!this.props.user.hasIn(['resource_access', client, 'roles']) || !this.props.user.getIn(['resource_access', client, 'roles']).includes(role)){
			if(mode === 'all'){
				valid = false;
				break;
			}
		}else{
			if(mode === 'any'){
				valid = true;
				break;
			}
		}
	}
	
	return valid;
  }
	
	render() {		
		const NavLink = ({ label, to, exact, icon }) => (
			<Menu.Item style={{fontWeight: 300}} onClick={() => this.props.push(to)} ><Icon name={icon} />{(typeof label !== 'undefined')?' ' + label:null}</Menu.Item>
		);
		return (
            <div>
                <Container fluid style={{
                        fontFamiliy: 'Roboto',
                        fontWeight: 400,
                        paddingTop: "41px"
                    }}>
					{this.props.children}
	          	</Container>
            </div>
        );

		return (
			  <div>
			  	{
			  		(false && this.props.alert)?
					  <Modal open centered basic size='small'>
					    <Header icon={this.props.alert.icon} content={this.props.alert.title} />
					    <Modal.Content>
					      <p style={{
					      	color: '#FFFFFF'
					      }}>
					      {this.props.alert.message}
					      </p>
					    </Modal.Content>
					    <Modal.Actions>
					      <Button fluid color='green' onClick={() => this.props.close_alert()}>
					        <Icon name='checkmark' /> {this.props.alert.button_ok}
					      </Button>
					    </Modal.Actions>
					  </Modal>
			  		:null
			  	}
			    <Menu borderless fixed='top' style={{
					backgroundColor: '#f4f4f4',
					boxShadow: 'none',
					fontFamily: 'Roboto',
					fontWeight: 300
				}}>			        
			         <Dropdown item text={<span><Icon name={this.props.icon} />  {this.props.title}</span>} style={{backgroundColor: 'rgb(0, 110, 215)', color: '#FFFFFF'}} >
                        <Dropdown.Menu>
                        	{
                        		(this.authorized(['imagetool:de.kisad.odst.ip']))?
                            		<Dropdown.Item href="/ip/"><Icon name="image" /> ImageTool</Dropdown.Item>
                            	:null
                            }
                            {
                        		(this.authorized(['de.kisad.odst.feeds.prints']))?
                            		<Dropdown.Item href={'' + __PREFIX__ + 'prints'}><Icon name="print" /> Printprogramme</Dropdown.Item>
                            	:null
                            }
                            <Dropdown.Item href={'' + __PREFIX__}><Icon name="share alternate" /> Feeds</Dropdown.Item>
                            {
                        		(this.authorized(['realm-management:view-users']))?
                            		<Dropdown.Item href="https://accounts.kisad.de/auth/admin/Oddset/console/"><Icon name="users" /> Benutzerverwaltung</Dropdown.Item>
                            	:null
                            }
                            
                        </Dropdown.Menu>
                    </Dropdown>
                    
                    {
                    	(typeof this.props.menu !== 'undefined')?
	                    	this.props.menu.map((menu) => {
	                    		if(typeof menu.auth !== 'undefined' && !this.authorized(menu.auth))return null;
	                    		
	                    		if(typeof menu.entries === 'undefined')
	                    			return (
	                    				<Menu.Item onClick={menu.onClick} active={menu.active}>
	                    					<Icon name={menu.icon} />
		                    				{menu.caption}
	                    				</Menu.Item>
	                    			)
	                    		else
		                    		return (
		                    			<Dropdown item text={
		                    				<span>
		                    					<Icon name={menu.icon} />
		                    					{menu.caption}
		                    				</span>
		                    			} style={{fontWeight: 300}}>
			                    			<Dropdown.Menu>
			                    			{
			                    				menu.entries.map((entry) => {
			                    					if(typeof entry.auth !== 'undefined' && !this.authorized(entry.auth))return null;
			                    					
			                    					return (
			                    						<Dropdown.Item href={entry.href}>
			                    							<Icon name={entry.icon} />
			                    							{entry.caption}
			                    						</Dropdown.Item>
			                    					)
			                    				})
			                    			}
			                    			</Dropdown.Menu>
		                    			</Dropdown>
		                			)
	
	                    	})
                    	:null
                    }

                    <Menu.Menu position='right'>
	        
	        
				        <Dropdown item text={
				        	<span>
				        		<Icon name="user" />
				        		{
				        			this.props.user.get('preferred_username')
				        		}
				        	</span>
				        } style={{fontWeight: 300}} >
			                <Dropdown.Menu>
			                    <Dropdown.Item href="https://accounts.kisad.de/auth/realms/Oddset/account"><Icon name="user" /> Benutzerprofil</Dropdown.Item>
			                    <Dropdown.Item href={'' + __PREFIX__ + 'logout'}><Icon name="lock" /> Abmelden</Dropdown.Item>
			                </Dropdown.Menu>
			            </Dropdown>
			
				      </Menu.Menu>
			    </Menu>
				<Container fluid style={{
					fontFamiliy: 'Roboto',
					fontWeight: 400,
					paddingTop: "41px"
				}}>
					{this.props.children}
	          	</Container>
	        </div>
		)
	}
}

export const Navigation = connect(
  mapStateToProps,
  Object.assign({}, actionCreators)
)(NavigationComponent)